import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, MenuItem, Typography, Box } from "@mui/material";
import axios from "axios";
import baseUrl from "../../../config/baseUrl";

function SecretKey() {
  const auth = sessionStorage.getItem("user");

  // Secret Key related states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [showSecret, setShowSecret] = useState(false);

  const handleSecretKeyFetch = async () => {
    try {
      let values = { email, password };
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${auth}`,
        },
      };
      const result = await axios.post(`${baseUrl}/showHideKey`, values, config);
      if (result.data.data) {
        setSecretKey(result.data.data[0].secretkey);
        setShowSecret(true);

        // Hide secret key after 30 seconds
        setTimeout(() => {
          setShowSecret(false);
          setEmail("");
          setPassword("");
          setSecretKey("");
        }, 10000);
      } else {
        alert(result.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          variant="outlined"
          size="small"
          sx={{ mb: 2 }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="password"
          label="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          variant="outlined"
          size="small"
          sx={{ mb: 2 }}
        />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2} alignItems="center">
          {/* Secret Key Box - Left Side */}
          <Grid item xs={12} sm={8}>
            {showSecret && (
              <Box
                sx={{
                  p: 2,
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  background: "#f7f7f7",
                }}
              >
                <Typography variant="subtitle2" color="primary">
                  Secret Key (visible only for 10 seconds):
                </Typography>
                <Typography variant="body1" sx={{ wordBreak: "break-word" }}>
                  {secretKey}
                </Typography>
              </Box>
            )}
          </Grid>

          {/* Button - Right Side */}
          <Grid item xs={12} sm={4} textAlign={{ xs: "left", sm: "right" }}>
            <Button
              onClick={handleSecretKeyFetch}
              variant="contained"
              color="success"
              size="medium"
            >
              Get Secret Key
            </Button>
          </Grid>
        </Grid>
      </Grid>

    </Grid>
  );
}

export default SecretKey;
